<template>
    <div class='share-panel'>
        <a class="share-button" href="javascript:;"></a>
        <div class="share-links clearfix">
            <a class="share-link wb-share-link" title="点击分享到微博" target="_blank"  v-bind:href="weiboShareLink"  v-on:click="wb"></a>

            <a class="share-link qq-share-link" title="点击分享到QQ空间" target="_blank" v-bind:href="qqShareLink"  v-on:click="qq"></a>

            <a class="share-link wx-share-link">
                <span class="qrcode" v-bind="{'data-route': $route.name }"></span>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: 'share',
    data(){
        return{
            shareConfig: this.$winConfig.shareConfig,
            qqShareLink:  encodeURI('http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='+this.$winConfig.shareConfig.url+'&desc='+this.$winConfig.shareConfig.description+'&summary='+this.$winConfig.shareConfig.description+'&site=&title='+this.$winConfig.shareConfig.title+'&pics='+this.$winConfig.shareConfig.image),
            weiboShareLink: encodeURI('http://v.t.sina.com.cn/share/share.php?title='+this.$winConfig.shareConfig.description+'&url='+this.$winConfig.shareConfig.url+'&source=中国原创音乐基地&pic='+this.$winConfig.shareConfig.image+'&appkey=3432766229&ralateUid=1750294477'),
        }
    },
    methods:{
        wb:function(){
            window["_czc"].push(["_trackEvent", this.shareConfig.title, '微博分享']);

             return true;
        },
        qq:function(){
            window["_czc"].push(["_trackEvent", this.shareConfig.title, 'QQ空间分享']);
            //cnzz(this, 'QQ空间分享'); 
            return true;
        }
    }
}
</script>
<style  rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.share-panel {
    position: absolute;
    top: 1490px;
    right: 50%;
    display: block;
    margin-right: -530px;
    z-index: 2;
}
.share-panel .share-button {
    position: absolute;
    top: 0;
    z-index: 2;
    display: block;
    width: 151px;
    height: 52px;
    transition: all .5s;
    background: url(componentsImgPath('share/0.png')) no-repeat;
}
.share-panel:hover .share-button {
    top: -35px;
}
.share-panel .share-links {
    position: absolute;
    bottom: -50px;
    width: 150px;
    text-align: center;
    visibility: hidden;
    transition: all .5s;
    opacity: 0;
    z-index: 1;
}
.share-panel:hover .share-links {
    opacity: 1;
    visibility: visible;
}
.share-panel .share-link {
    position: relative;
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-right: 20px;
    background: url(componentsImgPath('share/1.png')) no-repeat;
}
.share-panel .wb-share-link {
    background-position: -22px 0;
}
.share-panel .qq-share-link {
    background-position: 0 0;
}
.share-panel .wx-share-link {
    margin-right: 0;
    background-position: -110px 0;
}
.share-panel .qrcode {
    position: absolute;
    top: 30px;
    left: -109px;
    display: block;
    width: 150px;
    height: 150px;
    background: #fff;
    visibility: hidden;
    opacity: 0;
    transition: all .5s;
    background: url(componentsImgPath('share/2.png')) no-repeat;
}
.share-panel .qrcode[data-route="indexHome"]
{
    background-position: 0 0;
}
.share-panel .qrcode[data-route="indexRule"]
{
    background-position: -150px 0;
}
.share-panel .qrcode[data-route="indexWork"]
{
    background-position: 0 -150px;
}
.share-panel .qrcode[data-route="indexWinner"]
{
    background-position: -150px -150px;
}
.share-panel .wx-share-link:hover .qrcode {
    top: 25px;
    opacity: 1;
    visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/share.vue